"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return validateParams;
    }
});
const _ncError = require("./ncError");
function validateParams(props, body, option) {
    for (const prop of props){
        if (!(prop in body)) {
            _ncError.NcError.get({
                api_version: option == null ? void 0 : option.api_version
            }).invalidRequestBody(`Missing '${prop}' property in request body`);
        }
    }
}
